import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
    Card,
    Tabs,
    Typography,
    Space,
    Button,
} from "antd";
import {
    ApiOutlined,
    SettingOutlined,
    BellOutlined,
} from "@ant-design/icons";
import CallbackManagement from "./components/CallbackManagement/CallbackManagement.js";
import "./FeatureManagement.scss";

const { Title } = Typography;
const { TabPane } = Tabs;

class FeatureManagement extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: "callback",
        };
    }

    handleTabChange = (key) => {
        this.setState({ activeTab: key });
    };

    render() {
        const { activeTab } = this.state;

        return (
            <div className="feature-management">
                <div className="management-header">
                    <div className="header-left">
                        <Title level={2}>Feature Management</Title>
                        <p>Manage system features and configurations</p>
                    </div>
                </div>

                <div className="feature-tabs-card">
                    <Tabs
                        activeKey={activeTab}
                        onChange={this.handleTabChange}
                        size="large"
                    >
                        <TabPane
                            tab={
                                <span>
                                    <ApiOutlined />
                                    Callback Management
                                </span>
                            }
                            key="callback"
                        >
                            <CallbackManagement />
                        </TabPane>

                        {/* <TabPane
                            tab={
                                <span>
                                    <BellOutlined />
                                    Notifications
                                </span>
                            }
                            key="notifications"
                        >
                            <div className="coming-soon">
                                <Title level={4}>Coming Soon</Title>
                                <p>Notification management features will be available soon.</p>
                            </div>
                        </TabPane> */}
                    </Tabs>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    // Add any required state mappings here
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            // Add any required action creators here
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(FeatureManagement);
